<template>
  <div class="navbar-container d-flex content align-items-center justify-content-between">
    <!-- Nav Menu Toggler -->
    <ul
      class="nav navbar-nav d-xl-none"
      style="width: 15%"
    >
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>
    <div><vuexy-logo /></div>
    <div>
      <b-navbar-nav class="nav align-items-center ml-auto">
        <locale />
        <dark-toggler class="d-lg-block" />
        <!--      <search-bar />-->
        <!--        <cart-dropdown />-->
        <!--      <notification-dropdown />-->
        <!--        <user-dropdown />-->
      </b-navbar-nav>
    </div>
    <!-- Left Col -->
    <!--    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">-->

    <!-- Bookmarks Container -->
    <!--      <bookmarks />-->
    <!--    </div>-->
    <!--    <vuexy-logo />-->
  </div>
</template>

<script>
import {
  BImg,
  BLink,
  // BLink,
  BNavbarNav,
} from 'bootstrap-vue'
import store from '@/store'
import VuexyLogo from '@core/layouts/components/Logo.vue'
// import Bookmarks from './components/Bookmarks.vue'
import Locale from './components/Locale.vue'
// import SearchBar from './components/SearchBar.vue'
import DarkToggler from './components/DarkToggler.vue'
// import CartDropdown from './components/CartDropdown.vue'
// import NotificationDropdown from './components/NotificationDropdown.vue'
// import UserDropdown from './components/UserDropdown.vue'

export default {
  components: {
    BLink,
    VuexyLogo,
    BImg,
    // BLink,

    // Navbar Components
    BNavbarNav,
    // Bookmarks,
    Locale,
    // SearchBar,
    DarkToggler,
    // CartDropdown,
    // NotificationDropdown,
    // UserDropdown,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
}
</script>
